import { render } from "./ButtonMode.vue?vue&type=template&id=2c9f874d"
import script from "./ButtonMode.vue?vue&type=script&lang=js"
export * from "./ButtonMode.vue?vue&type=script&lang=js"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__